import React from 'react';
import { Card, Input } from '@avila-tek/ui/src';
import { FormHeader } from '../../shared/Forms';
import { Currency } from '../../../models';

interface CurrencyFormFields {
  formState: Partial<Currency>;
  setFormState: React.Dispatch<React.SetStateAction<Partial<Currency>>>;
}

function CurrencyFormFields({ formState, setFormState }: CurrencyFormFields) {
  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  return (
    <Card>
      <FormHeader
        href="/app/settings/currencies"
        title={formState._id ? 'Actualizar moneda' : 'Crear moneda'}
        backBtnText="Monedas"
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5 ">
          <div className="w-full">
            <Input
              value={formState?.name ?? ''}
              label="Nombre"
              type="text"
              placeholder="Ingrese un nombre"
              onChange={handleInputChange}
              name="name"
              required
            />
          </div>
          <div className="w-full">
            <Input
              value={formState?.symbol ?? ''}
              label="Simbolo"
              name="symbol"
              type="text"
              placeholder="Ingrese un simbolo"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full md:w-1/2 pr-2">
            <Input
              value={formState?.rate ?? ''}
              label="Tasa"
              type="number"
              name="rate"
              placeholder="Ingrese la tasa"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default CurrencyFormFields;
